/**
 * @desc 订单退款
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.WalmartOrderRefundRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/walmart/orderRefund`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
